import React from "react";
import Slider from "react-slick";

const ProofOfWork = () => {
  // Replace these with your actual image paths in /public or /src/assets
  const images = [
    "/images/proof1.jpg",
    "/images/proof2.jpg",
    "/images/proof3.jpg",
    "/images/proof4.jpg",
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  

  return (
    <section className="proof-of-work" style={{ padding: "60px 20px", textAlign: "center" }}>
      <h2 style={{ color: "ffffff", fontSize: "2.5rem", marginBottom: "2rem" }}>
        Proof of Work
      </h2>
      <Slider {...settings} style={{ maxWidth: "600px", margin: "0 auto" }}>
        {images.map((src, index) => (
    <div key={index}>
      <img
        src={src}
        alt={`Proof ${index + 1}`}
        style={{
          width: "100%",
          height: "auto",
          borderRadius: "10px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
          maxHeight: "400px", // ✅ cap the height so it’s not huge
          objectFit: "contain", // keep image aspect ratio
        }}
            />
          </div>
        ))}
      </Slider>
    </section>
  );
};

export default ProofOfWork;
